import CalendarChannelPickerPlaceholder from './components/CalendarChannelPicker.placeholder';
import { createLazyComponent, LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarChannelPicker" */ './lazyIndex')
);

export const CalendarChannelPicker = createLazyComponent(
    lazyModule,
    m => m.CalendarChannelPicker,
    CalendarChannelPickerPlaceholder
);

export const lazyInitializeCalendarChannelPicker = new LazyAction(
    lazyModule,
    m => m.initializeCalendarChannelPicker
);

export * from './store/schema/CalendarChannelPickerInterfaces';
